module.exports = __webpack_public_path__ + "static/media/arrow-left.24950ab5.svg";